export default __webpack_public_path__ + "static/media/floorplan.cdb5339b.png";